import { render, staticRenderFns } from "./Important.vue?vue&type=template&id=408d9b01&scoped=true"
import script from "./Important.vue?vue&type=script&lang=js"
export * from "./Important.vue?vue&type=script&lang=js"
import style0 from "./Important.vue?vue&type=style&index=0&id=408d9b01&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408d9b01",
  null
  
)

export default component.exports